  <app-table
    class="mt-5"
    [loading]="false"
    [columns]="ballotHistoryColumns"
    [data]="ballotHistoryItems"
    [pagination]="false"
    [id]="id"
  ></app-table>
